import React from "react";

function MakeUpPdf() {
  return <div>MakeUp</div>;
}

export default MakeUpPdf;
